import { render } from "./HonorableMentions.vue?vue&type=template&id=87c4666e&scoped=true"
import script from "./HonorableMentions.vue?vue&type=script&lang=js"
export * from "./HonorableMentions.vue?vue&type=script&lang=js"

import "./HonorableMentions.vue?vue&type=style&index=0&id=87c4666e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87c4666e"]])

export default __exports__